import type { CustomSession } from '@/types/auth'

const addAccessToken = async (headers: HeadersInit): Promise<void> => {
    if (typeof window === 'undefined') {
        const auth = await import('@/auth')

        const session: CustomSession | null = await auth.auth()

        if (!session) {
            return
        }

        const accessToken = session.accessToken

        if (!accessToken) {
            throw new Error('No access token found')
        }

        const headersAsRecords = headers as Record<string, string>
        headersAsRecords.Authorization = `Bearer ${accessToken}`
    }
}

export { addAccessToken }